import { apiClientGeral, apiClientAudio, apiCallCenter } from '@/plugins/axios'

export default {
  getintegracaosegware() {
    return apiClientGeral().get(`/integracoes/segware`)
  },
  postintegracaosegware(integracao) {
    return apiClientGeral().post('/integracoes/segware', integracao)
  },
  putintegracao(integracao) {
    return apiClientGeral().put(`/integracoes/${integracao._id}`, integracao)
  },
  deleteintegracao(id) {
    return apiClientGeral().delete(`/integracoes/${id}`)
  },
  getRamais() {
    return apiClientGeral().get('/ramais')
  },

  getTroncos() {
    return apiClientGeral().get('/troncos')
  },
  
  getTags() {
    return apiClientGeral().get('/tags')
  },

  getAudios() {
    return apiClientAudio().get('/audio')
  },
  
  getintegracaoIA(){
    return apiClientGeral().get('/integracoes/ia')
  },
  
  postintegracaoIA(integracao){
    return apiClientGeral().post('/integracoes/ia', integracao)
  },

  getOperadores() {
    return apiCallCenter().get('/agent')
  },
}
